import * as React from "react";

import { sanitizeForUi } from "@/shared/lib/sanitize-unicode";
import { cn } from "@/shared/lib/utils";

type TextareaProps = React.ComponentProps<"textarea"> & {
  disableUnicodeSanitize?: boolean;
};

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, disableUnicodeSanitize, onChange, id, ...props },
  ref
) {
  // KAN-301: у поля всегда есть id — см. Input
  const generatedId = React.useId();
  return (
    <textarea
      ref={ref}
      id={id ?? generatedId}
      data-slot="textarea"
      className={cn(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
      )}
      onChange={(e) => {
        if (!disableUnicodeSanitize && typeof e.target.value === "string") {
          const sanitized = sanitizeForUi(e.target.value);
          if (sanitized !== e.target.value) {
            e.target.value = sanitized;
          }
        }
        onChange?.(e);
      }}
      {...props}
    />
  );
});

export { Textarea };
